import { detailsBig, h3, h4, h6 } from "@/styles/typography";
import styled from "styled-components";

const CategoriesWrapper = styled.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 10px 20px 10px 0;
  margin-bottom: 45px;
`;

const FirstCategories = styled(detailsBig)`
  text-transform: uppercase;
  color: #4a4a4a;
  text-align: left;
  width: 440px;
`;

const SecondCategories = styled(detailsBig)`
  text-transform: uppercase;
  color: #4a4a4a;
  width: 300px;
  text-align: left;
`;
const Categories = styled(detailsBig)`
  text-transform: uppercase;
  color: #4a4a4a;
  width: 160px;
  text-align: left;
  white-space: nowrap;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  a,
  a:visited {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
  }

  a {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #a0a0a0;
    width: 100%;

    align-items: center;
    padding: 10px 20px 10px 0;

    transition: all 0.2s ease-in-out;
    margin-bottom: 10px;

    @media ${({ theme }) => theme.breakpoints.hover} {
      &:hover {
        box-shadow: inset 0px -4px 0px ${({ theme }) => theme.colors.primary};
      }
    }
  }

  margin-bottom: 200px;
`;

const ItemWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 100px;
`;

const ItemTitle = styled(h3)`
  color: ${({ theme }) => theme.colors.primary};
  width: 440px;
`;

const ItemText = styled(h4)`
  color: #424242;
  text-transform: uppercase;
  width: 300px;
`;

const ItemDate = styled(h4)`
  color: #424242;
  text-transform: uppercase;
  white-space: nowrap;
  width: 160px;
`;

const Wrapper = styled.div`
  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
`;

const MobileWrapper = styled.div`
  display: none;

  a,
  a:visited {
    text-decoration: none;
  }

  a {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #424242;
    width: 100%;
    max-width: 600px;
    margin-bottom: 10px;

    transition: all 0.2s ease-in-out;

    &:last-child {
      margin-bottom: 150px;
    }
    @media ${({ theme }) => theme.breakpoints.hover} {
      &:hover {
        box-shadow: inset 0px -4px 0px ${({ theme }) => theme.colors.primary};
      }
    }
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    display: initial;
  }
`;

const MobileItemWrapper = styled.div``;

const MobileTitle = styled(h4)`
  color: ${({ theme }) => theme.colors.primary};
`;

const MobileText = styled(h6)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.textColors.primary};
  margin-bottom: 5px;
`;

const S = {
  CategoriesWrapper,
  Categories,
  Container,
  ItemWrapper,
  ItemTitle,
  ItemText,
  ItemDate,
  FirstCategories,
  SecondCategories,
  Wrapper,
  MobileWrapper,
  MobileItemWrapper,
  MobileTitle,
  MobileText,
};

export default S;
